import React, { useState, useEffect } from "react";
import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalCloseButton,
    ModalBody,
    ModalFooter,
    Input,
    Button,
    VStack,
    FormControl,
    FormLabel,
    HStack,
} from "@chakra-ui/react";
import api from "../../utils/axios";

const UpdateSectionModal = ({ isOpen, onClose, section, handleUpdateSection }) => {
    const [updatedName, setUpdatedName] = useState(section?.name || "");

    useEffect(() => {
        setUpdatedName(section?.name || "");
    }, [section]);

    const handleSubmit = async () => {
        if (!section?.id || !updatedName) return;
        try {
            const response = await api.get(`/section/${section.id}/name/${updatedName}`);
            handleUpdateSection(response.data);
            onClose();
        } catch (error) {
            console.error("Error updating section:", error);
        }
    };

    return (
        <Modal isOpen={isOpen} onClose={onClose}>
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>Ažuriraj odjeljak: {section?.name || "Unknown Section"}</ModalHeader>
                <ModalCloseButton />
                <ModalBody>
                    <VStack spacing={4} align="stretch">
                        <FormControl>
                            <FormLabel>Naziv odjeljka</FormLabel>
                            <Input
                                placeholder="Enter new section name"
                                value={updatedName}
                                onChange={(e) => setUpdatedName(e.target.value)}
                            />
                        </FormControl>
                    </VStack>
                </ModalBody>
                <ModalFooter>
                    <HStack spacing={4}>
                        <Button colorScheme="blue" onClick={handleSubmit}>Ažuriraj</Button>
                        <Button onClick={onClose}>Povratak</Button>
                    </HStack>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
};

export default UpdateSectionModal;